/** Data shaping for the Reportes charts */

import { localDateStr } from './dailyClose';

export interface DayPoint {
  /** 'YYYY-MM-DD' */
  day: string;
  count: number;
  cumulative: number;
}

const addDays = (day: string, n: number) => {
  const d = new Date(`${day}T12:00:00`);
  d.setDate(d.getDate() + n);
  return localDateStr(d);
};

/** Registrations per local day, with the empty days in between filled (continuous timeline) */
export function registrationsByDay(registrationDates: string[]): DayPoint[] {
  if (registrationDates.length === 0) return [];
  const counts = new Map<string, number>();
  for (const iso of registrationDates) {
    const day = localDateStr(iso);
    counts.set(day, (counts.get(day) ?? 0) + 1);
  }
  const days = [...counts.keys()].sort();
  const points: DayPoint[] = [];
  let cumulative = 0;
  for (let day = days[0]; day <= days[days.length - 1]; day = addDays(day, 1)) {
    const count = counts.get(day) ?? 0;
    cumulative += count;
    points.push({ day, count, cumulative });
  }
  return points;
}
